class BundleTravelForm extends HTMLElement {
  constructor() {
    super();
    this.bindMethods();
  }
  
    bindMethods() {
    const methods = [
      'handleSubmit', 'handleIncrease', 'handleDecrease',
      'handleIncreaseHotel', 'handleDecreaseHotel',
      'updatePriceDisplay', 'updateSummary', 'updateMaxQuantities',
      'goToNextStep', 'goToStep', 'setupStepHeaders', 'getProductAvailability',
      'findNextAvailableStep', 'calculateTotalBeds', 'filterHotelVariantsByNights',
      'checkAllInventory', 'checkVariantInventory', 'updatePacoteAvailability',
      'updateNightsAvailability', 'updateFlightAvailability', 'updateHotelAvailability',
      'updatePacotePreview', 'updateNightsPreview', 'collectSelectedItems', 'addMultipleItems',
      'formatCurrency', 'resetSelectionsAfter', 'getSortedHotelInputs', 'updateHotelMaxQuantities',
      'updatePacoteConfirmButton', 'updateNightsConfirmButton', 'updateFlightConfirmButton',
      'setupFloatingButton', 'updateFloatingSummary', 'toggleFloatingResumo', 
      'setupFloatingButtons', 'handleFloatingAddToCart', 'updateFloatingButtons',
      'updateCartDrawer', 'reinitializeCheckoutButton', 'dispatchCartUpdate', 'selectFlightByNights',
      'setupHotelSelection', 'filterRoomsByHotel', 'updateHotelSelectionConfirmButton',
      'updateHotelSelectionPreview', 'updateRoomConfirmButton', 'resetRoomSelections'
    ];
  
      methods.forEach(method => {
        if (this[method]) this[method] = this[method].bind(this);
      });
    }
  
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
  
      this.initializeForm();
      this.setupEventListeners();
    this.setupFloatingButton();
    this.setupFloatingButtons();
  
      const primeiraEtapa = this.steps[0];
      if (primeiraEtapa) {
        primeiraEtapa.classList.add('visited');
      }
  
      this.updateMaxQuantities();
      this.updatePriceDisplay();
      this.updateSummary();

    if (this.hasPacote) {
      this.updatePacoteConfirmButton();
    }

    if (this.hasNights) {
      this.updateNightsConfirmButton();
    }

    if (this.hasHotel) {
      this.updateHotelSelectionConfirmButton();
      this.updateRoomConfirmButton();
    }

    if (this.hasVoo) {
      this.updateFlightConfirmButton();
    }
  
      const checkInventory = this.querySelector('#check_inventory');
      if (checkInventory && checkInventory.value === 'true') {
        this.checkAllInventory();
      }
    }
  
    initializeForm() {
      this.getProductAvailability();
  
      const mainBundleEl = document.getElementById('ec-main-bundle-product');
      this.productId = mainBundleEl ? mainBundleEl.getAttribute('data-product-id') : null;

      this.quantityInput = this.form.querySelector('input[name="quantidade"]');
      this.hotelQuantityInputs = this.hasHotel ? this.form.querySelectorAll('.hotel-quantity') : [];
      this.addButton = this.form.querySelector('#add-bundle');
  
      this.summaryPacote = this.hasPacote ? this.form.querySelector('.summary-pacote') : null;
      this.summaryNights = this.hasNights ? this.form.querySelector('.summary-nights') : null;
      this.summaryHotel = this.hasHotel ? this.form.querySelector('.summary-hotel') : null;
      this.summaryVoo = this.hasVoo ? this.form.querySelector('.summary-voo') : null;
  
      // Armazena o hotel selecionado
      this.selectedHotel = null;
      this.selectedNights = null;
  
      this.steps = this.form.querySelectorAll('.bundle-step:not(.hidden)');
      this.currentStepIndex = 0;
      this.visitedSteps = [0];
  
      if (this.steps[0] && !this.steps[0].classList.contains('visited')) {
        this.steps[0].classList.add('visited');
      }
    }
  
    setupEventListeners() {
      this.addButton?.addEventListener('click', this.handleSubmit);
  
      const increaseBtn = this.form.querySelector('.increase-qty');
      const decreaseBtn = this.form.querySelector('.decrease-qty');
      increaseBtn?.addEventListener('click', this.handleIncrease);
      decreaseBtn?.addEventListener('click', this.handleDecrease);

      this.setupQuantityLimitDismiss();
      this.setupHotelSelection();
      this.setupHotelEventListeners();
      this.setupNightsSelection();
      this.setupFlightSelection();
  
      this.quantityInput.addEventListener('change', () => {
        this.updateMaxQuantities();
        this.updatePriceDisplay();
        this.updateSummary();
      });
  
      if (this.hasPacote) {
        this.form.querySelectorAll('input[name="variant_pacote"]').forEach(input => {
          input.addEventListener('change', () => {
            this.updatePriceDisplay();
            this.updateSummary();
            this.updatePacotePreview(input);
          this.updatePacoteConfirmButton();
          });
        });
      }
  
      this.form.querySelectorAll('.confirm-step').forEach(button => {
        button.addEventListener('click', () => {
          if (button.id !== 'add-bundle') {
            this.goToNextStep();
          }
        });
      });
  
      this.setupStepHeaders();
    }
  
    setupHotelEventListeners() {
      if (!this.hasHotel) return;
  
      const increaseHotelBtns = this.form.querySelectorAll('.increase-qty-hotel');
      const decreaseHotelBtns = this.form.querySelectorAll('.decrease-qty-hotel');
  
      increaseHotelBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          const quantityInput = e.target.closest('.hotel-option').querySelector('.hotel-quantity');
          this.handleIncreaseHotel(quantityInput);
        });
      });
  
      decreaseHotelBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          const quantityInput = e.target.closest('.hotel-option').querySelector('.hotel-quantity');
          this.handleDecreaseHotel(quantityInput);
        });
      });
  
      this.hotelQuantityInputs.forEach(input => {
        input.addEventListener('change', () => {
          this.updatePriceDisplay();
          this.updateSummary();
        });
      });
    }
  
    setupNightsSelection() {
      if (!this.hasNights) return;
  
      const nightsTypeInputs = this.form.querySelectorAll('input[name="nights_type"]');
      nightsTypeInputs.forEach(input => {
        input.addEventListener('change', () => {
          if (input.checked) {
            // Use nights-display for filtering hotels (only nights part)
            const selectedTitle = input.dataset.nightsDisplay || input.dataset.title.split(' / ')[0];
            this.selectedNights = selectedTitle;
            
            // Resetar seleções de quartos quando muda de noites
            this.resetRoomSelections();
            
            // Filtrar quartos pelo hotel e noites selecionados
            this.filterRoomsByHotelAndNights();
            
            // Auto-select flight based on nights
            if (this.hasVoo) {
              this.selectFlightByNights(selectedTitle);
            }
            
            this.updateNightsPreview(input);
            this.updatePriceDisplay();
            this.updateSummary();
            this.updateNightsConfirmButton();
          }
        });
      });
    }
  
    setupFlightSelection() {
      if (!this.hasVoo) return;
  
      const flightInputs = this.form.querySelectorAll('input[name="flight_variant"]');
      flightInputs.forEach(input => {
        input.addEventListener('change', () => {
          this.updatePriceDisplay();
          this.updateSummary();
          this.updateFlightConfirmButton();
        });
      });
    }

    setupHotelSelection() {
      if (!this.hasHotel) return;

      const hotelInputs = this.form.querySelectorAll('input[name="selected_hotel"]');
      hotelInputs.forEach(input => {
        input.addEventListener('change', () => {
          if (input.checked) {
            this.selectedHotel = input.dataset.hotel;
            this.updateHotelSelectionPreview(input);
            this.updateHotelSelectionConfirmButton();
            
            // Resetar seleções de quartos quando muda de hotel
            this.resetRoomSelections();
            
            // Filtrar quartos pelo hotel e noites selecionados
            this.filterRoomsByHotelAndNights();
          }
        });
      });
    }

    filterRoomsByHotel(selectedHotelName) {
      if (!this.hasHotel) return;

      // Mostrar seção do hotel selecionado e esconder as outras
      const hotelSections = this.form.querySelectorAll('.bundle-room .hotel-section');
      hotelSections.forEach(section => {
        const hotelName = section.dataset.hotel;
        if (hotelName === selectedHotelName) {
          section.style.display = 'block';
        } else {
          section.style.display = 'none';
        }
      });
    }

    filterRoomsByHotelAndNights() {
      if (!this.hasHotel) return;

      // Primeiro filtrar seções de hotel
      if (this.selectedHotel) {
        this.filterRoomsByHotel(this.selectedHotel);
      }

      // Depois filtrar por noites se já selecionadas
      if (this.selectedNights) {
        const hotelOptions = this.form.querySelectorAll('.bundle-room .hotel-option');
        hotelOptions.forEach(option => {
          const hotelName = option.dataset.hotel;
          const nightsValue = option.dataset.nights;
          
          // Mostrar apenas se é do hotel selecionado E das noites selecionadas
          if (hotelName === this.selectedHotel && nightsValue === this.selectedNights) {
            option.style.display = 'flex';
          } else {
            option.style.display = 'none';
            // Resetar quantidade se estava selecionado
            const qtyInput = option.querySelector('.hotel-quantity');
            if (qtyInput) qtyInput.value = 0;
          }
        });
      }

      this.updatePriceDisplay();
      this.updateSummary();
    }

    updateHotelSelectionPreview(input) {
      const hotelName = input.dataset.hotel;
      const hotelSelectionStep = this.form.querySelector('.bundle-hotel-selection');
      if (!hotelSelectionStep) return;
      
      const allPreviews = hotelSelectionStep.querySelectorAll('.hotel-preview-item');
      const placeholder = hotelSelectionStep.querySelector('.ec-ticket-preview-placeholder');

      allPreviews.forEach(preview => {
        if (preview.dataset.hotel === hotelName) {
          preview.style.display = 'block';
          if (placeholder) placeholder.style.display = 'none';
        } else {
          preview.style.display = 'none';
        }
      });
    }

    updateHotelSelectionConfirmButton() {
      if (!this.hasHotel) return;
      
      const hotelSelectionStep = this.form.querySelector('.bundle-step[data-step="4"]');
      if (!hotelSelectionStep || !hotelSelectionStep.classList.contains('bundle-hotel-selection')) return;
      
      const confirmButton = hotelSelectionStep.querySelector('.confirm-hotel-selection-step');
      if (!confirmButton) return;
      
      const selectedInput = this.form.querySelector('input[name="selected_hotel"]:checked');
      
      if (selectedInput) {
        confirmButton.disabled = false;
        confirmButton.textContent = 'Confirmar hotel';
        confirmButton.style.opacity = '1';
        confirmButton.style.cursor = 'pointer';
      } else {
        confirmButton.disabled = true;
        confirmButton.textContent = 'Selecione um hotel';
        confirmButton.style.opacity = '0.5';
        confirmButton.style.cursor = 'not-allowed';
      }
    }

    updateRoomConfirmButton() {
      if (!this.hasHotel) return;
      
      const roomStep = this.form.querySelector('.bundle-step[data-step="5"]');
      if (!roomStep || !roomStep.classList.contains('bundle-room')) return;
      
      const confirmButton = roomStep.querySelector('.confirm-room-step');
      if (!confirmButton) return;
      
      const totalBeds = this.calculateTotalBeds();
      const quantity = parseInt(this.quantityInput.value) || 1;
      
      if (totalBeds >= quantity) {
        confirmButton.disabled = false;
        confirmButton.textContent = 'Confirmar quarto';
        confirmButton.style.opacity = '1';
        confirmButton.style.cursor = 'pointer';
      } else {
        confirmButton.disabled = true;
        confirmButton.textContent = `Selecione quartos para ${quantity} pessoa(s)`;
        confirmButton.style.opacity = '0.5';
        confirmButton.style.cursor = 'not-allowed';
      }
    }

    resetRoomSelections() {
      if (!this.hasHotel) return;

      // Resetar todas as quantidades de quartos
      this.hotelQuantityInputs.forEach(input => {
        input.value = 0;
      });

      this.updatePriceDisplay();
      this.updateSummary();
      this.updateRoomConfirmButton();
    }
  
    setupStepHeaders() {
      this.steps.forEach((step, index) => {
        const header = step.querySelector('h3');
        if (!header) return;
  
        header.style.cursor = 'pointer';
  
        header.addEventListener('click', () => {
          if (index < this.currentStepIndex || this.visitedSteps.includes(index)) {
            this.goToStep(index);
          }
        });
  
        const editIcon = header.querySelector('.edit-step-icon');
        if (editIcon) {
          editIcon.addEventListener('click', (e) => {
            e.stopPropagation();
            if (index < this.currentStepIndex || this.visitedSteps.includes(index)) {
              this.goToStep(index);
            }
          });
        }
      });
  
      if (this.steps[0]) {
        this.steps[0].classList.add('visited');
      }
    }
  
    getProductAvailability() {
      const hasPacote = this.querySelector('#has_pacote');
      const hasNights = this.querySelector('#has_noites');
      const hasHotel = this.querySelector('#has_hotel');
      const hasVoo = this.querySelector('#has_voo');
      const quantidadeParcelas = this.querySelector('#quantidade_parcelas');
      const initialProductPrice = this.querySelector('#initial_product_price');
  
      this.hasPacote = hasPacote ? hasPacote.value === 'true' : false;
      this.hasNights = hasNights ? hasNights.value === 'true' : false;
      this.hasHotel = hasHotel ? hasHotel.value === 'true' : false;
      this.hasVoo = hasVoo ? hasVoo.value === 'true' : false;
      this.quantidadeParcelas = quantidadeParcelas ? parseInt(quantidadeParcelas.value) || 10 : 10;
      this.initialProductPrice = initialProductPrice ? parseInt(initialProductPrice.value) || 0 : 0;
    }
  
    findNextAvailableStep(currentIndex) {
      if (currentIndex < this.steps.length - 1) {
        return currentIndex + 1;
      }
      return -1;
    }
  
    goToNextStep() {
      const nextIndex = this.findNextAvailableStep(this.currentStepIndex);
  
      if (nextIndex > 0) {
        this.goToStep(nextIndex);
  
        if (!this.visitedSteps.includes(nextIndex)) {
          this.visitedSteps.push(nextIndex);
        }
      }
    }
  
    goToStep(stepIndex) {
      if (stepIndex >= 0 && stepIndex < this.steps.length) {
        this.steps[this.currentStepIndex].classList.remove('active');
  
        this.resetSelectionsAfter(stepIndex);
  
        this.currentStepIndex = stepIndex;
  
        this.steps[this.currentStepIndex].classList.add('active');
        this.steps[this.currentStepIndex].setAttribute('data-height', this.steps[this.currentStepIndex].scrollHeight);
  
        this.steps.forEach((step, index) => {
          if (index <= stepIndex) {
            step.classList.add('visited');
          } else {
            step.classList.remove('visited');
          }
        });
  
        this.steps[this.currentStepIndex].scrollIntoView({ behavior: 'smooth' });
  
        if (!this.visitedSteps.includes(stepIndex)) {
          this.visitedSteps.push(stepIndex);
        }
  
        this.updatePriceDisplay();
        this.updateSummary();
      }
    }
  
    resetSelectionsAfter(stepIndex) {
      // Reseta seleções das etapas posteriores quando volta para uma etapa anterior
      if (stepIndex < this.currentStepIndex) {
        // Implementar reset se necessário
      }
    }
  
    filterHotelVariantsByNights(selectedNightsTitle) {
      const hotelOptions = this.form.querySelectorAll('.hotel-option');
  
      hotelOptions.forEach(option => {
        const variantData = option.querySelector('.hotel-variant-data');
        const nightsValue = variantData.dataset.nights;
  
        if (nightsValue === selectedNightsTitle) {
          option.style.display = 'flex';
        } else {
          option.style.display = 'none';
          // Resetar quantidade se estava selecionado
          const qtyInput = option.querySelector('.hotel-quantity');
          if (qtyInput) qtyInput.value = 0;
        }
      });
  
      this.updatePriceDisplay();
      this.updateSummary();
    }

    selectFlightByNights(selectedNightsTitle) {
      if (!this.hasVoo) return;
      
      // Extrair apenas o número de noites (ex: "3 noites" -> "3")
      const nightsNumber = selectedNightsTitle.split(' ')[0];
      
      const flightOptions = this.form.querySelectorAll('.flight-option-item');
      const flightInputs = this.form.querySelectorAll('input[name="flight_variant"]');
      
      let flightFound = false;
      
      // Ocultar todas as opções de voo primeiro
      flightOptions.forEach(option => {
        option.style.display = 'none';
      });
      
      // Desmarcar todos os inputs
      flightInputs.forEach(input => {
        input.checked = false;
      });
      
      // Encontrar e selecionar o voo correspondente
      flightInputs.forEach(input => {
        const flightNights = input.dataset.nights;
        
        if (flightNights === nightsNumber) {
          const label = input.closest('.flight-option-item');
          if (label) {
            label.style.display = 'flex';
            
            // Auto-selecionar se não estiver esgotado
            const isSoldOut = input.dataset.soldOut === 'true';
            if (!isSoldOut) {
              input.checked = true;
              flightFound = true;
            }
          }
        }
      });
      
      // Mostrar mensagem se não houver voo disponível
      const soldOutMessage = this.form.querySelector('.bundle-voo .sold-out-message');
      if (soldOutMessage) {
        soldOutMessage.style.display = flightFound ? 'none' : 'block';
      }
      
      // Atualizar o botão de confirmação de voo
      this.updateFlightConfirmButton();
      
      // Atualizar preço e resumo
      this.updatePriceDisplay();
      this.updateSummary();
    }
  
    handleIncrease() {
      const currentValue = parseInt(this.quantityInput.value) || 1;
      const maxValue = parseInt(this.quantityInput.getAttribute('max')) || 999;
  
      if (currentValue < maxValue) {
        this.quantityInput.value = currentValue + 1;
        this.updateMaxQuantities();
        this.updatePriceDisplay();
        this.updateSummary();
      }
    }
  
    handleDecrease() {
      const currentValue = parseInt(this.quantityInput.value) || 1;
      const minValue = parseInt(this.quantityInput.getAttribute('min')) || 1;
  
      if (currentValue > minValue) {
        this.quantityInput.value = currentValue - 1;
        this.updateMaxQuantities();
        this.updatePriceDisplay();
        this.updateSummary();
      }
    }
  
    handleIncreaseHotel(quantityInput) {
      if (!this.hasHotel) return;
      
      const currentValue = parseInt(quantityInput.value) || 0;
      const maxQuantity = parseInt(this.quantityInput.value) || 1;
      const bedQuantity = parseInt(quantityInput.dataset.step) || 1;
      const maxValue = parseInt(quantityInput.getAttribute('max')) || 999;
      
      // Check inventory limit
      if (currentValue >= maxValue) {
        console.log(`Não é possível adicionar mais quartos. Limite de estoque: ${maxValue}.`);
        return;
      }
      
      // Calculate total beds before and after adding
      const totalBeds = this.calculateTotalBeds();
      const newTotalBeds = totalBeds + bedQuantity;
      
      // Only allow if new total doesn't exceed person count
      if (newTotalBeds <= maxQuantity) {
        quantityInput.value = currentValue + 1;
        this.updatePriceDisplay();
        this.updateSummary();
        this.updateRoomConfirmButton();
        
        // Auto-advance if beds match person count exactly
        const updatedTotalBeds = this.calculateTotalBeds();
        if (updatedTotalBeds === maxQuantity) {
          this.goToNextStep();
        }
      } else {
        this.showQuantityLimitTooltip(quantityInput, this.buildQuantityLimitMessage(maxQuantity, 'cama', 'camas'));
      }
    }

    buildQuantityLimitMessage(maxQuantity, singularLabel, pluralLabel) {
      const itemLabel = maxQuantity === 1 ? singularLabel : pluralLabel;
      return `Máximo de ${maxQuantity} ${itemLabel}: 1 por ingresso comprado. <strong>Adicione mais pacotes na etapa 1.</strong>`;
    }

    showQuantityLimitTooltip(quantityInput, message) {
      const anchor = quantityInput.closest('.quantity-selector');
      if (!anchor) return;

      this.hideQuantityLimitTooltip();

      const tooltip = document.createElement('div');
      tooltip.className = 'quantity-limit-tooltip';
      tooltip.setAttribute('role', 'alert');
      tooltip.innerHTML = message;
      anchor.after(tooltip);

      this.quantityLimitTooltip = tooltip;
    }

    hideQuantityLimitTooltip() {
      this.quantityLimitTooltip?.remove();
      this.quantityLimitTooltip = null;
    }

    setupQuantityLimitDismiss() {
      this.form.addEventListener('click', (event) => {
        if (event.target.closest('.quantity-selector')) this.hideQuantityLimitTooltip();
      }, true);
    }

    handleDecreaseHotel(quantityInput) {
      const currentValue = parseInt(quantityInput.value) || 0;
      const minValue = parseInt(quantityInput.getAttribute('min')) || 0;
  
      if (currentValue > minValue) {
        quantityInput.value = currentValue - 1;
        this.updatePriceDisplay();
        this.updateSummary();
        this.updateRoomConfirmButton();
      }
    }
  
    updateMaxQuantities() {
      const quantity = parseInt(this.quantityInput.value) || 1;
  
      if (this.hasPacote) {
        this.updatePacoteAvailability(quantity);
      }
  
      if (this.hasVoo) {
        this.updateFlightAvailability(quantity);
      }
  
      if (this.hasHotel) {
        this.updateHotelAvailability(quantity);
        this.updateHotelMaxQuantities(quantity);
      }
    }
  
    updatePacoteAvailability(quantity) {
      const pacoteInputs = this.form.querySelectorAll('input[name="variant_pacote"]');
      let hasAvailable = false;
  
      pacoteInputs.forEach(input => {
        const inventory = parseInt(input.dataset.inventory) || 0;
        const label = input.closest('.bundle-option');
  
        if (inventory >= quantity) {
          label.classList.remove('sold-out');
          input.disabled = false;
          hasAvailable = true;
        } else {
          label.classList.add('sold-out');
          if (input.checked) {
            input.checked = false;
          }
        }
      });
  
      const soldOutMessage = this.form.querySelector('.bundle-pacote .sold-out-message');
      if (soldOutMessage) {
        soldOutMessage.style.display = hasAvailable ? 'none' : 'block';
      }
    }
  
    updateFlightAvailability(quantity) {
      const flightInputs = this.form.querySelectorAll('input[name="flight_variant"]');
      let hasAvailable = false;
  
      flightInputs.forEach(input => {
        const inventory = parseInt(input.dataset.inventory) || 0;
        const label = input.closest('.bundle-option');
  
        if (inventory >= quantity) {
          label.classList.remove('sold-out');
          input.disabled = false;
          hasAvailable = true;
        } else {
          label.classList.add('sold-out');
          if (input.checked) {
            input.checked = false;
          }
        }
      });
  
      const soldOutMessage = this.form.querySelector('.bundle-voo .sold-out-message');
      if (soldOutMessage) {
        soldOutMessage.style.display = hasAvailable ? 'none' : 'block';
      }
    }
  
    updateHotelAvailability(quantity) {
      // Atualiza disponibilidade baseado em camas necessárias
    }
  
    updateHotelMaxQuantities(maxQuantity) {
      if (!this.hasHotel || this.hotelQuantityInputs.length === 0) return;
      
      const totalBeds = this.calculateTotalBeds();
      
      // Only adjust if total beds exceeds person count
      if (totalBeds > maxQuantity && totalBeds > 0) {
        const sortedInputs = this.getSortedHotelInputs();
        
        let remainingBeds = totalBeds;
        
        // Remove rooms until total beds <= person count
        for (const input of sortedInputs) {
          const bedQuantity = parseInt(input.dataset.step) || 1;
          let currentValue = parseInt(input.value) || 0;
          
          while (currentValue > 0 && remainingBeds > maxQuantity) {
            currentValue--;
            remainingBeds -= bedQuantity;
          }
          
          input.value = currentValue;
        }
        
        this.updatePriceDisplay();
        this.updateSummary();
      }
    }
  
    getSortedHotelInputs() {
      return Array.from(this.hotelQuantityInputs)
        .filter(input => parseInt(input.value) > 0)
        .sort((a, b) => {
          const aVisible = a.closest('.hotel-option').style.display !== 'none';
          const bVisible = b.closest('.hotel-option').style.display !== 'none';
          
          // Prioritize removing from hidden rooms first
          if (aVisible !== bVisible) return aVisible ? 1 : -1;
          return 0;
        });
    }
  
    updatePacotePreview(input) {
      const variantId = input.value;
      const pacoteStep = this.form.querySelector('.bundle-pacote');
      if (!pacoteStep) return;
      
      const allPreviews = pacoteStep.querySelectorAll('.ec-ticket-image-preview');
      const placeholder = pacoteStep.querySelector('.ec-ticket-preview-placeholder');
  
      allPreviews.forEach(preview => {
        if (preview.dataset.variant === variantId) {
          preview.style.display = 'block';
          if (placeholder) placeholder.style.display = 'none';
  
          const soldOut = input.dataset.soldOut === 'true';
          const badge = preview.querySelector('.ec-ticket-sold-out-badge');
          if (badge) {
            badge.style.display = soldOut ? 'block' : 'none';
          }
        } else {
          preview.style.display = 'none';
        }
      });
    }
  
    updateNightsPreview(input) {
      const variantId = input.value;
      const nightsStep = this.form.querySelector('.bundle-nights');
      if (!nightsStep) return;
      
      const allPreviews = nightsStep.querySelectorAll('.ec-ticket-image-preview');
      const placeholder = nightsStep.querySelector('.ec-ticket-preview-placeholder');
  
      allPreviews.forEach(preview => {
        if (preview.dataset.variant === variantId) {
          preview.style.display = 'block';
          if (placeholder) placeholder.style.display = 'none';
  
          const soldOut = input.dataset.soldOut === 'true';
          const badge = preview.querySelector('.ec-ticket-sold-out-badge');
          if (badge) {
            badge.style.display = soldOut ? 'block' : 'none';
          }
        } else {
          preview.style.display = 'none';
        }
      });
    }
  
    calculateTotalBeds() {
      if (!this.hasHotel) return 0;
  
      let totalBeds = 0;
  
      this.form.querySelectorAll('.hotel-option').forEach(option => {
        if (option.style.display !== 'none') {
          const quantityInput = option.querySelector('.hotel-quantity');
          const variantData = option.querySelector('.hotel-variant-data');
          const quantity = parseInt(quantityInput.value) || 0;
  
          if (quantity > 0) {
            const beds = parseInt(variantData.dataset.beds) || 1;
            totalBeds += (beds * quantity);
          }
        }
      });
  
      return totalBeds;
    }
  
    calculatePacotePrice() {
      if (!this.hasPacote) return 0;
  
      const pacoteInput = this.form.querySelector('input[name="variant_pacote"]:checked');
      if (!pacoteInput) return 0;
  
      const quantity = parseInt(this.quantityInput.value) || 1;
      const price = parseInt(pacoteInput.dataset.price) || 0;
  
      return price * quantity;
    }
  
    calculateNightsPrice() {
      if (!this.hasNights) return 0;
  
      const nightsInput = this.form.querySelector('input[name="nights_type"]:checked');
      if (!nightsInput) return 0;
  
      const price = parseInt(nightsInput.dataset.price) || 0;
      return price;
    }
  
    calculateHotelPrice() {
      if (!this.hasHotel) return 0;
  
      let totalHotelPrice = 0;
  
      this.form.querySelectorAll('.hotel-option').forEach(option => {
        if (option.style.display !== 'none') {
          const quantityInput = option.querySelector('.hotel-quantity');
          const variantData = option.querySelector('.hotel-variant-data');
          const quantity = parseInt(quantityInput.value) || 0;
  
          if (quantity > 0) {
            const price = parseInt(variantData.dataset.price) * quantity;
            totalHotelPrice += price;
          }
        }
      });
  
      return totalHotelPrice;
    }
  
    calculateFlightPrice() {
      if (!this.hasVoo) return 0;
  
      const flightInput = this.form.querySelector('input[name="flight_variant"]:checked');
      if (!flightInput) return 0;
  
      const quantity = parseInt(this.quantityInput.value) || 1;
      const price = parseInt(flightInput.dataset.price) || 0;
  
      return price * quantity;
    }
  
  
    updatePacoteSummary(quantity) {
      if (!this.hasPacote || !this.summaryPacote) return;
  
      const pacoteInput = this.form.querySelector('input[name="variant_pacote"]:checked');
      if (pacoteInput) {
        const title = pacoteInput.dataset.title;
  
        this.summaryPacote.style.display = 'block';
        this.summaryPacote.querySelector('.selected-pacote').textContent = title;
        this.summaryPacote.querySelector('.pacote-quantity').textContent = `Quantidade: ${quantity}`;
      } else {
        this.summaryPacote.style.display = 'none';
      }
    }

    updatePriceDisplay() {
      const pacotePrice = this.calculatePacotePrice();
      const nightsPrice = this.calculateNightsPrice();
      const hotelPrice = this.calculateHotelPrice();
      const flightPrice = this.calculateFlightPrice();

      const totalPrice = pacotePrice + nightsPrice + hotelPrice + flightPrice;

      const totalPriceElement = this.form.querySelector('.total-price');

      if (totalPriceElement) {
        totalPriceElement.textContent = this.formatCurrency(totalPrice / 100);
      }
      
      const mainPriceDisplay = document.querySelector('.ec-product-main-infos-price h2');
      if (mainPriceDisplay && totalPrice > 0) {
        const installmentValue = (totalPrice / 100) / this.quantidadeParcelas;
        mainPriceDisplay.textContent = `a partir de ${this.quantidadeParcelas}x de R$ ${installmentValue.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}`;
      }
    }
  
    updateNightsSummary() {
      if (!this.hasNights || !this.summaryNights) return;
  
      const nightsInput = this.form.querySelector('input[name="nights_type"]:checked');
      if (nightsInput) {
        const title = nightsInput.dataset.title;
  
        this.summaryNights.style.display = 'block';
        this.summaryNights.querySelector('.selected-nights').textContent = title;
      } else {
        this.summaryNights.style.display = 'none';
      }
    }
  
    updateHotelSummary() {
      if (!this.hasHotel || !this.summaryHotel) return;
  
      const selectedHotels = [];
      let totalHotelQuantity = 0;
  
      this.form.querySelectorAll('.hotel-option').forEach(option => {
        if (option.style.display !== 'none') {
          const quantityInput = option.querySelector('.hotel-quantity');
          const variantData = option.querySelector('.hotel-variant-data');
          const quantity = parseInt(quantityInput.value) || 0;
  
          if (quantity > 0) {
            const title = variantData.dataset.title;
            selectedHotels.push(`${title} (${quantity}x)`);
            totalHotelQuantity += quantity;
          }
        }
      });
  
      if (selectedHotels.length > 0) {
        this.summaryHotel.style.display = 'block';
        this.summaryHotel.querySelector('.selected-hotel').textContent = selectedHotels.join(', ');
      } else {
        this.summaryHotel.style.display = 'none';
      }
    }
  
    updateFlightSummary(quantity) {
      if (!this.hasVoo || !this.summaryVoo) return;
  
      const flightInput = this.form.querySelector('input[name="flight_variant"]:checked');
      if (flightInput) {
        const title = flightInput.dataset.title;
  
        this.summaryVoo.style.display = 'block';
        this.summaryVoo.querySelector('.selected-voo').textContent = title;
        this.summaryVoo.querySelector('.voo-quantity').textContent = `Quantidade: ${quantity} passagem(ns)`;
      } else {
        this.summaryVoo.style.display = 'none';
      }
    }
  
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value);
    }
  
    checkAllInventory() {
      const quantity = parseInt(this.quantityInput.value) || 1;
  
      if (this.hasPacote) {
        this.updatePacoteAvailability(quantity);
      }
  
      if (this.hasVoo) {
        this.updateFlightAvailability(quantity);
      }
    }
  
    checkVariantInventory(variantId, quantity) {
      // Implementar verificação de inventário se necessário
      return true;
    }
  
    async handleSubmit(e) {
      e.preventDefault();
  
      // Validações
      const quantity = parseInt(this.quantityInput.value) || 1;
  
      if (this.hasPacote) {
        const pacoteInput = this.form.querySelector('input[name="variant_pacote"]:checked');
        if (!pacoteInput) {
          alert('Por favor, selecione um pacote de viagem.');
          return;
        }
      }
  
      if (this.hasNights) {
        const nightsInput = this.form.querySelector('input[name="nights_type"]:checked');
        if (!nightsInput) {
          alert('Por favor, selecione a quantidade de noites.');
          return;
        }
      }
  
      if (this.hasHotel) {
        const hotelInput = this.form.querySelector('input[name="selected_hotel"]:checked');
        if (!hotelInput) {
          alert('Por favor, selecione um hotel.');
          return;
        }

        const totalBeds = this.calculateTotalBeds();
        if (totalBeds === 0) {
          alert('Por favor, selecione pelo menos um quarto de hotel.');
          return;
        }
  
        if (totalBeds < quantity) {
          alert(`O total de camas (${totalBeds}) deve ser pelo menos igual à quantidade de pessoas (${quantity}).`);
          return;
        }
      }
  
      if (this.hasVoo) {
        const flightInput = this.form.querySelector('input[name="flight_variant"]:checked');
        if (!flightInput) {
          alert('Por favor, selecione um voo. O voo é obrigatório para este pacote.');
          return;
        }
      }
  
      // Coletar itens selecionados
      const items = this.collectSelectedItems();
  
      if (items.length === 0) {
        alert('Por favor, selecione os produtos antes de finalizar.');
        return;
      }
  
      // Adicionar ao carrinho
      this.addButton.disabled = true;
      this.addButton.textContent = 'Adicionando...';
  
      try {
        const cartDrawer = document.querySelector('cart-drawer');
        let result;
        
        result = await this.addMultipleItems(items, cartDrawer);
        
        if (result && cartDrawer) {
          this.updateCartDrawer(cartDrawer, result);
          this.dispatchCartUpdate();
          setTimeout(() => this.reinitializeCheckoutButton(), 500);
        }
        
        this.addButton.disabled = false;
        this.addButton.textContent = 'Finalizar Compra';
      } catch (error) {
        console.error('Erro ao adicionar ao carrinho:', error);
        alert('Erro ao adicionar ao carrinho. Por favor, tente novamente.');
        this.addButton.disabled = false;
        this.addButton.textContent = 'Finalizar Compra';
      }
    }
  
    collectSelectedItems() {
      const quantity = parseInt(this.quantityInput.value) || 1;
      const items = [];
      const bundleId = Date.now();
      
      const bundleProperty = { '_bundleId': bundleId };
      
      if (this.productId) {
        bundleProperty['_productId'] = this.productId;
      }
  
      // Adicionar pacote
      if (this.hasPacote) {
        const pacoteInput = this.form.querySelector('input[name="variant_pacote"]:checked');
        if (pacoteInput) {
          items.push({
            id: parseInt(pacoteInput.value),
            quantity: quantity,
            properties: { ...bundleProperty, '_itemType': 'pacote' }
          });
        }
      }

      // Adicionar noites
      if (this.hasNights) {
        const nightsInput = this.form.querySelector('input[name="nights_type"]:checked');
        if (nightsInput) {
          items.push({
            id: parseInt(nightsInput.value),
            quantity: 1,
            properties: { ...bundleProperty, '_itemType': 'noites' }
          });
        }
      }

      // Adicionar quartos de hotel
      if (this.hasHotel) {
        this.form.querySelectorAll('.hotel-option').forEach(option => {
          if (option.style.display !== 'none') {
            const quantityInput = option.querySelector('.hotel-quantity');
            const variantData = option.querySelector('.hotel-variant-data');
            const qty = parseInt(quantityInput.value) || 0;

            if (qty > 0) {
              items.push({
                id: parseInt(variantData.dataset.id),
                quantity: qty,
                properties: { ...bundleProperty, '_itemType': 'hotel' }
              });
            }
          }
        });
      }

      // Adicionar voo
      if (this.hasVoo) {
        const flightInput = this.form.querySelector('input[name="flight_variant"]:checked');
        if (flightInput) {
          items.push({
            id: parseInt(flightInput.value),
            quantity: quantity,
            properties: { ...bundleProperty, '_itemType': 'voo' }
          });
        }
      }

      return items;
    }

    async addMultipleItems(items, cartDrawer) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      const result = await response.json();

      if (!response.ok) {
        const message = result.description || 'Erro desconhecido';
        alert(`Erro ao adicionar ao carrinho: ${message}`);
        return null;
      }

      await window.saveBundleDetailsToCartAttributes(this, this.productId);

      if (cartDrawer) {
        const sectionsToRender = cartDrawer.getSectionsToRender().map(s => s.id);
        const sectionsResponse = await fetch(`${window.location.pathname}?sections=${sectionsToRender.join(',')}`);
        const updatedSections = await sectionsResponse.json();
        
        return { ...result, sections: updatedSections };
      }
      
      return result;
    }

    updateCartDrawer(cartDrawer, result) {
      cartDrawer.renderContents(result);
      
      cartDrawer.classList.remove('is-empty');
      const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
      if (cartDrawerItems) {
        cartDrawerItems.classList.remove('is-empty');
      }
    }

    reinitializeCheckoutButton() {
      const checkoutButton = document.getElementById('CartDrawer-Checkout');
      if (!checkoutButton) return;

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const hasItems = cart.items.length > 0;
          checkoutButton.disabled = !hasItems;
          checkoutButton.textContent = 'Finalizar a compra';
          checkoutButton.style.opacity = hasItems ? '1' : '0.6';
          checkoutButton.style.cursor = hasItems ? 'pointer' : 'not-allowed';
        })
        .catch(() => {
          checkoutButton.disabled = false;
          checkoutButton.textContent = 'Finalizar a compra';
          checkoutButton.style.opacity = '1';
          checkoutButton.style.cursor = 'pointer';
        });
    }

    dispatchCartUpdate() {
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { source: 'bundle-travel-form' }
      }));
    }

    updatePacoteConfirmButton() {
      if (!this.hasPacote) return;
      
      const pacoteStep = this.form.querySelector('.bundle-step[data-step="2"]');
      if (!pacoteStep) return;
      
      const confirmButton = pacoteStep.querySelector('.confirm-step');
      if (!confirmButton) return;
      
      const selectedInput = this.form.querySelector('input[name="variant_pacote"]:checked');
      
      if (selectedInput) {
        const isSoldOut = selectedInput.dataset.soldOut === 'true';
        
        if (isSoldOut) {
          confirmButton.disabled = true;
          confirmButton.textContent = 'Pacote esgotado';
          confirmButton.style.opacity = '0.5';
          confirmButton.style.cursor = 'not-allowed';
        } else {
          confirmButton.disabled = false;
          confirmButton.textContent = 'Confirmar pacote';
          confirmButton.style.opacity = '1';
          confirmButton.style.cursor = 'pointer';
        }
      } else {
        confirmButton.disabled = true;
        confirmButton.textContent = 'Selecione um pacote';
        confirmButton.style.opacity = '0.5';
        confirmButton.style.cursor = 'not-allowed';
      }
    }

    updateNightsConfirmButton() {
      if (!this.hasNights) return;
      
      const nightsStep = this.form.querySelector('.bundle-step[data-step="3"]');
      if (!nightsStep) return;
      
      const confirmButton = nightsStep.querySelector('.confirm-step');
      if (!confirmButton) return;
      
      const selectedInput = this.form.querySelector('input[name="nights_type"]:checked');
      
      if (selectedInput) {
        const isSoldOut = selectedInput.dataset.soldOut === 'true';
        
        if (isSoldOut) {
          confirmButton.disabled = true;
          confirmButton.textContent = 'Quantidade de noites esgotada';
          confirmButton.style.opacity = '0.5';
          confirmButton.style.cursor = 'not-allowed';
        } else {
          confirmButton.disabled = false;
          confirmButton.textContent = 'Confirmar noites';
          confirmButton.style.opacity = '1';
          confirmButton.style.cursor = 'pointer';
        }
      } else {
        confirmButton.disabled = true;
        confirmButton.textContent = 'Selecione a quantidade de noites';
        confirmButton.style.opacity = '0.5';
        confirmButton.style.cursor = 'not-allowed';
      }
    }

    updateFlightConfirmButton() {
      if (!this.hasVoo) return;
      
      const vooStep = this.form.querySelector('.bundle-step[data-step="6"]');
      if (!vooStep) return;
      
      const confirmButton = vooStep.querySelector('.confirm-step');
      if (!confirmButton) return;
      
      const selectedInput = this.form.querySelector('input[name="flight_variant"]:checked');
      
      if (selectedInput) {
        const isSoldOut = selectedInput.dataset.soldOut === 'true';
        
        if (isSoldOut) {
          confirmButton.disabled = true;
          confirmButton.textContent = 'Voo esgotado';
          confirmButton.style.opacity = '0.5';
          confirmButton.style.cursor = 'not-allowed';
        } else {
          confirmButton.disabled = false;
          confirmButton.textContent = 'Avançar para o resumo';
          confirmButton.style.opacity = '1';
          confirmButton.style.cursor = 'pointer';
        }
      } else {
        confirmButton.disabled = true;
        confirmButton.textContent = 'Selecione um voo';
        confirmButton.style.opacity = '0.5';
        confirmButton.style.cursor = 'not-allowed';
      }
    }

    setupFloatingButton() {
      const floatingButton = document.querySelector('.ec-bundle-product-floating-button');
      if (floatingButton) {
        floatingButton.addEventListener('click', this.toggleFloatingResumo);
      }
    }

    setupFloatingButtons() {
      const addToCartFloating = document.querySelector('#add-to-cart-bundle-floating');
      const closeButton = document.querySelector('.floating-drawer-close');
      
      if (addToCartFloating) {
        addToCartFloating.addEventListener('click', this.handleFloatingAddToCart);
      }
      
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          const floatingResumo = document.querySelector('.ec-bundle-product-floating-resumo');
          if (floatingResumo) {
            floatingResumo.classList.remove('show');
          }
        });
      }
    }

    toggleFloatingResumo() {
      const floatingResumo = document.querySelector('.ec-bundle-product-floating-resumo');
      
      if (floatingResumo) {
        const isVisible = floatingResumo.classList.contains('show');
        
        if (isVisible) {
          floatingResumo.classList.remove('show');
        } else {
          floatingResumo.classList.add('show');
          this.updateFloatingSummary();
        }
      }
    }

    async updateSummary() {
      const quantity = parseInt(this.quantityInput.value) || 1;
      
      this.updatePacoteSummary(quantity);
      this.updateNightsSummary();
      this.updateHotelSummary();
      this.updateFlightSummary(quantity);
      
      const floatingResumo = document.querySelector('.ec-bundle-product-floating-resumo');
      if (floatingResumo && floatingResumo.classList.contains('show')) {
        this.updateFloatingSummary();
      }
      
      this.updateFloatingButtons();
    }

    updateFloatingSummary() {
      if (!document.querySelector('.ec-bundle-product-floating-resumo')) return;
      
      const quantity = parseInt(this.quantityInput.value) || 1;
      
      this.updatePacoteFloatingSummary(quantity);
      this.updateNightsFloatingSummary();
      this.updateHotelFloatingSummary();
      this.updateFlightFloatingSummary(quantity);
      this.updateTotalFloatingSummary();
      this.updateFloatingButtons();
    }

    updatePacoteFloatingSummary(quantity) {
      if (!this.hasPacote) return;
      
      const summaryPacoteElements = document.querySelectorAll('.summary-pacote-floating');
      if (!summaryPacoteElements.length) return;
      
      const pacoteInput = this.form.querySelector('input[name="variant_pacote"]:checked');
      if (pacoteInput) {
        const title = pacoteInput.dataset.title;
        
        summaryPacoteElements.forEach(el => el.style.display = 'flex');
        
        const quantityElement = document.querySelector('.pacote-quantity-floating');
        if (quantityElement) {
          quantityElement.textContent = quantity;
        }
        
        const selectedElement = document.querySelector('.selected-pacote-floating');
        if (selectedElement) {
          selectedElement.textContent = title;
        }
      } else {
        summaryPacoteElements.forEach(el => el.style.display = 'none');
      }
    }

    updateNightsFloatingSummary() {
      if (!this.hasNights) return;
      
      const summaryNightsElements = document.querySelectorAll('.summary-nights-floating');
      if (!summaryNightsElements.length) return;
      
      const nightsInput = this.form.querySelector('input[name="nights_type"]:checked');
      if (nightsInput) {
        const title = nightsInput.dataset.title;
        
        summaryNightsElements.forEach(el => el.style.display = 'flex');
        
        const selectedElement = document.querySelector('.selected-nights-floating');
        if (selectedElement) {
          selectedElement.textContent = title;
        }
      } else {
        summaryNightsElements.forEach(el => el.style.display = 'none');
      }
    }

    updateHotelFloatingSummary() {
      if (!this.hasHotel) return;
      
      const summaryHotelElements = document.querySelectorAll('.summary-hotel-floating');
      if (!summaryHotelElements.length) return;
      
      const selectedHotels = [];
      let totalHotelQuantity = 0;
      
      this.form.querySelectorAll('.hotel-option').forEach(option => {
        if (option.style.display !== 'none') {
          const quantityInput = option.querySelector('.hotel-quantity');
          const variantData = option.querySelector('.hotel-variant-data');
          const quantity = parseInt(quantityInput.value) || 0;
          
          if (quantity > 0) {
            const beds = parseInt(variantData.dataset.beds) || 1;
            
            selectedHotels.push({
              title: variantData.dataset.title,
              quantity: quantity,
              beds: beds,
              totalBeds: quantity * beds
            });
            totalHotelQuantity += quantity;
          }
        }
      });
      
      if (selectedHotels.length > 0) {
        summaryHotelElements.forEach(el => el.style.display = 'flex');
        
        const selectedHotelElement = document.querySelector('.selected-hotel-floating');
        if (selectedHotelElement && selectedHotels.length > 0) {
          let hotelText = '';
          selectedHotels.forEach(hotel => {
            hotelText += `${hotel.title} (x${hotel.quantity})`;
            if (selectedHotels.indexOf(hotel) < selectedHotels.length - 1) {
              hotelText += '<br>';
            }
          });
          selectedHotelElement.innerHTML = hotelText;
        }
      } else {
        summaryHotelElements.forEach(el => el.style.display = 'none');
      }
    }

    updateFlightFloatingSummary(quantity) {
      if (!this.hasVoo) return;
      
      const summaryVooElements = document.querySelectorAll('.summary-voo-floating');
      if (!summaryVooElements.length) return;
      
      const flightInput = this.form.querySelector('input[name="flight_variant"]:checked');
      if (flightInput) {
        const title = flightInput.dataset.title;
        
        summaryVooElements.forEach(el => el.style.display = 'flex');
        
        const vooQuantityElement = document.querySelector('.voo-quantity-floating');
        if (vooQuantityElement) {
          vooQuantityElement.textContent = `Quantidade: ${quantity} passagem(ns)`;
        }
      } else {
        summaryVooElements.forEach(el => el.style.display = 'none');
      }
    }

    updateTotalFloatingSummary() {
      let totalPrice = 0;
      
      totalPrice += this.calculatePacotePrice();
      totalPrice += this.calculateNightsPrice();
      totalPrice += this.calculateHotelPrice();
      totalPrice += this.calculateFlightPrice();
      
      const pricePerPerson = totalPrice / 100;
      const installment = pricePerPerson / this.quantidadeParcelas;
      
      const subtotalElement = document.querySelector('.floating-subtotal-value');
      const totalElement = document.querySelector('.floating-total-value');
      
      if (subtotalElement) {
        subtotalElement.textContent = this.formatCurrency(pricePerPerson);
      }
      
      if (totalElement) {
        totalElement.textContent = `ou ${this.quantidadeParcelas}x de ${this.formatCurrency(installment)}`;
      }
    }

    updateFloatingButtons() {
      const addToCartFloating = document.querySelector('#add-to-cart-bundle-floating');
      
      if (!addToCartFloating) return;
      
      const isOnSummaryStep = this.currentStepIndex !== undefined && 
                             this.steps && 
                             this.steps[this.currentStepIndex] && 
                             this.steps[this.currentStepIndex].dataset.step === '7';
      
      if (!isOnSummaryStep) {
        addToCartFloating.disabled = true;
        return;
      }
      
      const selectedItems = this.collectSelectedItems();
      const hasItems = selectedItems.length > 0;
      
      let hasValidSelection = true;
      
      if (this.hasPacote) {
        const pacoteInput = this.form.querySelector('input[name="variant_pacote"]:checked');
        if (!pacoteInput) {
          hasValidSelection = false;
        }
      }
      
      if (this.hasNights) {
        const nightsInput = this.form.querySelector('input[name="nights_type"]:checked');
        if (!nightsInput) {
          hasValidSelection = false;
        }
      }
      
      if (this.hasHotel) {
        const hotelInput = this.form.querySelector('input[name="selected_hotel"]:checked');
        if (!hotelInput) {
          hasValidSelection = false;
        }
      }

      if (this.hasVoo) {
        const flightInput = this.form.querySelector('input[name="flight_variant"]:checked');
        if (!flightInput) {
          hasValidSelection = false;
        }
      }
      
      const shouldEnable = hasItems && hasValidSelection;
      
      addToCartFloating.disabled = !shouldEnable;
    }

    async handleFloatingAddToCart(e) {
      e.preventDefault();

      const selectedItems = this.collectSelectedItems();
      if (selectedItems.length === 0) {
        return;
      }

      const addToCartButton = e.target;
      addToCartButton.disabled = true;
      addToCartButton.textContent = 'Finalizando...';

      try {
        const cartDrawer = document.querySelector('cart-drawer');
        let result;
        
        result = await this.addMultipleItems(selectedItems, cartDrawer);
        
        if (result) {
          if (cartDrawer) {
            this.updateCartDrawer(cartDrawer, result);
            this.dispatchCartUpdate();
            
            cartDrawer.open();
          }
          
          const floatingResumo = document.querySelector('.ec-bundle-product-floating-resumo');
          if (floatingResumo) {
            floatingResumo.classList.remove('show');
          }
        }

      } catch (err) {
        console.error('Erro ao adicionar ao carrinho:', err);
        alert('Erro ao adicionar itens ao carrinho. Tente novamente.');
      } finally {
        addToCartButton.disabled = false;
        addToCartButton.textContent = 'Adicionar ao Carrinho';
      }
    }
  }

  customElements.define('bundle-travel-product-form', BundleTravelForm);